import { html } from "lit";
import { renderPageTemplate } from "../../../utils";
import { formatHtml } from "@trumpf/ux.common-storybook";
import { getIframePageDecorators } from "../../../shared/page";
import { NewsroomStageSliderTemplate } from "../../partial-templates/newsroom-blocks/stage-slider.templates";
import { NewsroomPressTwoColumnsTemplate } from "../../partial-templates/newsroom-blocks/press-block.templates";
import { NewsroomStoryBlockTemplate } from "../../partial-templates/newsroom-blocks/story-block.templates";
import { NewsroomHighlightTemplate } from "../../partial-templates/newsroom-blocks/highlight-block.templates";
import { SocialMediaWallTemplate } from "../../partial-templates/newsroom-blocks/social-media-wall.templates";
import { NewsroomClientMagazineTemplate } from "../../partial-templates/newsroom-blocks/client-magazine.templates";
import { BusinessYearTemplate } from "../../partial-templates/newsroom-blocks/business-year.templates";
import { QuicklinksTemplate } from "../../partial-templates/newsroom-blocks/quicklinks.templates";

const NewsroomPageTemplate = () => {
    return html`
        ${NewsroomStageSliderTemplate()} ${NewsroomPressTwoColumnsTemplate()}
        ${QuicklinksTemplate()}
        ${NewsroomStoryBlockTemplate({
            tabs: [
                { id: "neue-artikel", label: "Neue Artikel" },
                { id: "laser", label: "Laser" },
                { id: "industrie-4-0", label: "Industrie 4.0" },
                { id: "blech", label: "Blech" },
                { id: "zukunft", label: "Zukunft" },
                { id: "arbeitswelt", label: "Arbeitswelt" },
                { id: "meinung", label: "Meinung" },
            ],
        })}
        ${NewsroomHighlightTemplate({
            title: "Highlight Topic Lorem ipsum Dolor",
            icon: "globe",
            ctaText: "Mehr erfahren",
            ctaLink: "#",
        })}
        ${SocialMediaWallTemplate()} ${NewsroomClientMagazineTemplate()}
        ${BusinessYearTemplate()}
    `;
};

export default {
    title: "Website/Page Templates/Newsroom",
    render: NewsroomPageTemplate.bind({}),
    decorators: getIframePageDecorators(),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
        layout: "fullscreen",
    },
};

export const Default = () => renderPageTemplate(() => NewsroomPageTemplate());
